import styles from './contact-list-item.module.scss';

<template>
  <li
    class="{{styles.component}} contact-list-item {{if @isDisabled 'disabled'}}"
    data-test-contact-list-item={{@contactId}}
    ...attributes
  >
    {{yield}}
  </li>
</template>
